const $$splitComponentImporter = () => import('/app/frontend/src/routes/_auth/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';

/** Fallback backdrop until a screen declares its own via `staticData`. */

/**
 * Layout group for the authenticated-but-pre-app "state screens" (deactivated,
 * onboarding, gate, no-tenants, pending, tenant picker, server-error). Its
 * `beforeLoad` bounces unauthenticated visitors (e.g. right after signing out
 * from the tenant picker) to login, then guarantees the profile is settled
 * before any screen renders; each screen self-guards to the exact
 * `frontendUserState` it represents.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({
    context,
    location
  }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }
    await context.ensureProfile();
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});